import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { LazyLoadComponent } from '@src/components/LazyLoadComponent/LazyLoadComponent';

const SimsList = lazy(() =>
    import('../../pages/Sims').then((module) => ({
        default: module.SimsList,
    }))
);

const SimDetails = lazy(() =>
    import('../../pages/Sims').then((module) => ({
        default: module.SimDetails,
    }))
);

export function SimsContainer() {
    return (
        <Routes>
            <Route
                path={''}
                element={
                    <LazyLoadComponent type="LIST" Component={<SimsList />} />
                }
            />
            <Route
                path={'details/:id'}
                element={
                    <LazyLoadComponent type="PAGE" Component={<SimDetails />} />
                }
            />
        </Routes>
    );
}
